import React from 'react';
import { Loader2 } from 'lucide-react';

/**
 * Shown while a lazy-loaded route chunk is downloading (see App.tsx / layout Suspense
 * boundaries). Matches the in-page loading style used by ContentPlayPage etc.
 */
export const RouteFallback: React.FC = () => (
    <div className="route-fallback flex min-h-[60vh] w-full items-center justify-center p-8">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
    </div>
);

export default RouteFallback;
